import React, { useContext } from "react";
import { ShieldAlert } from "lucide-react";
import { AuthContext } from "../context/Auth";
import { Navigate } from "react-router-dom";
import { Button, Card } from "./ui";

export const AdminOnly = ({ children }) => {
    const { signed, isAdmin } = useContext(AuthContext);

    if (!signed) {
        return <Navigate to="/" />;
    }

    if (!isAdmin) {
        return (
            <div className="flex min-h-screen items-center justify-center p-4">
                <Card className="chat-up w-full max-w-md p-8 text-center">
                    <span className="mx-auto flex size-12 items-center justify-center rounded-full bg-red-500/10 text-red-500"><ShieldAlert className="size-6" /></span>
                    <h2 className="mt-4 text-xl font-medium tracking-tight">Acesso negado</h2>
                    <p className="mt-2 text-sm text-neutral-500 dark:text-neutral-400">Só administradores podem acessar o painel administrativo.</p>
                    <Button className="mt-6 w-full" onClick={() => { window.location.href = '/'; }}>Voltar ao login</Button>
                </Card>
            </div>
        );
    }

    return children;
};
